import { render, staticRenderFns } from "./tooltip-tertiary.vue?vue&type=template&id=0eb20b60&scoped=true&"
import script from "./tooltip-tertiary.vue?vue&type=script&lang=js&"
export * from "./tooltip-tertiary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eb20b60",
  null
  
)

export default component.exports